import { Info } from "lucide-react";

const CarrierTable = ({
  carriers,
}) => {
  if (!carriers?.length) return null;

  return (
    <div className="em-table-section">
      <h3>Resumen por servicio</h3>

      <table className="em-table">
        <thead>
          <tr>
            <th>Servicio</th>
            <th>Consumo</th>
            <th>kWh equiv.</th>
            <th>Costo</th>
            <th>Precio Prom.</th>
            <th>% Energía</th>
            <th>% Costo</th>
          </tr>
        </thead>
        <tbody>
          {carriers.map((c) => (
            <tr key={c.id}>
              <td>{c.label}</td>

              <td>
                {(c.kWh_canonical ||
                  c.m3 ||
                  0
                ).toFixed(2)}{" "}
                {c.unit}
                <i title={c.source_used  === "meter" ? "Medidor" : c.source_used === "invoice" ? "Factura" : "Fuente no especificada"}>
                  <Info size={14} />
                </i>
              </td>

              <td>
                {(c.kWh_equiv ||
                  c.kWh_canonical ||
                  0
                ).toFixed(2)}
              </td>

              <td>
                $
                {(c.cost || 0).toFixed(2)}
              </td>

              <td>
                {c.price_avg
                  ? `$${c.price_avg.toFixed(
                      2
                    )}`
                  : "—"}
              </td>

              <td>
                {c.share_energy
                  ? c.share_energy.toFixed(
                      1
                    ) + "%"
                  : "—"}
              </td>

              <td>
                {c.share_cost
                  ? c.share_cost.toFixed(
                      1
                    ) + "%"
                  : "—"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CarrierTable;